import {
  IntegrationTermsAndConditions,
  IntergrationInstructionInput,
  IntergrationInstructionStep,
  StrVal
} from '../../../../lib/api/account-linking/types';

export function validateInput(input: IntergrationInstructionInput, value: string): string | null {
  const val = value || '';

  if (input.validationRules.required && !val) {
    return input.validationRules.helperText || 'This field is required';
  }

  if (input.validationRules.pattern && val) {
    try {
      if (!new RegExp(input.validationRules.pattern).test(val)) {
        return input.validationRules.helperText || 'Please enter a valid value';
      }
    } catch {
      // malformed pattern from API - treat as valid to avoid blocking the user
    }
  }

  return null;
}

export function IsIntegrationValid(
  values: StrVal,
  steps: IntergrationInstructionStep[],
  termsAndConditions: IntegrationTermsAndConditions
): boolean {
  let output = true;

  steps.forEach((step) => {
    step.inputs?.forEach((input) => {
      if (validateInput(input, values[input.propertyName] || '')) {
        output = false;
      }
    });
  });

  if (termsAndConditions) {
    if (validateInput(termsAndConditions.input, values[termsAndConditions.input.propertyName] || '')) {
      output = false;
    }
  }

  return output;
}

export function ValidationErrorMessages(validationErrors: { [name: string]: string }, errorCode: string): string[] {
  const msg: string[] = [];
  switch (errorCode) {
    case '1000':
      msg.push('We are unable to find your account.');
      break;

    case '1001':
      msg.push('This account already exists.');
      break;

    case '1002':
      msg.push('The integration version you are using is not supported.');
      break;

    case '1003':
      msg.push('We can not verify the credentials you have entered.');
      break;

    default: {
      try {
        for (const m in validationErrors) {
          msg.push((validationErrors[m] as any)[0].message);
        }
      } catch {
        console.log('Error parsing validation errors');
      }
    }
  }

  return msg.length > 0 ? msg : ['Unable to link account, please try again.'];
}
